import FullpageModalContainer from './components/FullpageModalContainer.vue'
import FullpageModal from './components/FullpageModal.vue'

export default {
  install (Vue, options = {}) {
    if (Vue.prototype.$FModal) {
      return
    }

    const eventInterface = new Vue()
    const pluginStatus = {}
    let i18nInstance = null

    const $FModal = {
      show: function (...args) {
            if (!pluginStatus.containerBound) {
                pluginStatus.containerBound = true

                const globalDiv = document.createElement('div')
                document.body.appendChild(globalDiv)

                const vm = new Vue({
                i18n: i18nInstance,
                render: h => h(FullpageModalContainer)
                }).$mount(globalDiv)

                // Várjuk meg hogy a container feliratkozzon az eventekre
                vm.$nextTick(() => {
                if (typeof args[0] === 'object') {
                    eventInterface.$emit('show-dynamic', ...args)
                }
                })
                return
            }

            if (typeof args[0] === 'object') {
                eventInterface.$emit('show-dynamic', ...args)
            }
            },
      hide: function (...args) {
        eventInterface.$emit('hide-dynamic', ...args)
      },
      destroyAll: function () {
        eventInterface.$emit('destroy-all')
      },
      eventInterface
    }

    Object.defineProperty(Vue.prototype, '$FModal', {
      get: function () {
        if (!i18nInstance && this.$i18n) {
          i18nInstance = this.$i18n
        }
        return $FModal
      }
    })

    Vue.component('fullpage-modal', FullpageModal)
  }
}
